module.exports = __webpack_public_path__ + "img/dinersClub.9163dd90.svg";